var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 .8C3.5.8.335 3.485.335 7.635c0 2.65 2.042 5.767 6.117 9.358a.848.848 0 0 0 1.108 0c4.067-3.591 6.108-6.708 6.108-9.358 0-4.15-3.166-6.833-6.666-6.833Zm0 8.334c-.916 0-1.666-.75-1.666-1.667 0-.916.75-1.666 1.667-1.666.916 0 1.666.75 1.666 1.666 0 .917-.75 1.667-1.666 1.667Z",
    fill: "#2BB9A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9d2e1a3f112422058e24c5163c648649.svg";
export { ForwardRef as ReactComponent };